import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { ContactComponent } from './contact/contact.component';
import { ImprintComponent } from './imprint/imprint.component';
import { StairsComponent } from './stairs/stairs.component';
import { ChimneyComponent } from './chimney/chimney.component';
import { ChimneyImagesComponent } from './chimney-images/chimney-images.component';
import { StairsImagesComponent } from './stairs-images/stairs-images.component';
import { RegistrationComponent } from './registration/registration.component';
import { HouseChimneyImagesComponent } from './house-chimney-images/house-chimney-images.component';

const routes: Routes = [
  { path: '',    component: MainComponent    },
  { path: 'main',    component: MainComponent    },
  { path: 'Contact',    component: ContactComponent    },
  { path: 'imprint', component: ImprintComponent },
  { path: 'Stairs', component: StairsComponent },
  { path: 'StairsImages', component: StairsImagesComponent },
  { path: 'Chimney', component: ChimneyComponent },
  { path: 'ChimneyImages/renovation', component: ChimneyImagesComponent },
  { path: 'signIn', component: RegistrationComponent },
  { path: 'ChimneyImages/houseChimney', component: HouseChimneyImagesComponent },
  // { path: 'workinghours', component: WorkingComponent} 

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
